<template>
  <widget-step-page
    :btn-next-disabled="isBtnNextDisabled"
    :btn-prev-disabled="false"
    :on-btn-prev-clicked="onBtnPrevClicked"
    :on-btn-next-clicked="onBtnNextClicked"
  >
    <template #content>
      <div class="px-4 pb-14 pt-4">
        <div class="d-flex flex-column">
          <span
            class="mb-4"
          >Выберите услугу:</span>

          <template v-if="serviceList.length > 0">
            <v-radio-group
              v-model="localServiceId"
              dense
              class="mt-0 pt-0 mb-3"
            >
              <template v-for="service in serviceList">
                <x-radio
                  :value="service.id"
                >
                  <template #label>
                    <div class="d-flex flex-row align-center pl-2">
                      <div class="d-flex flex-column">
                        <div style="font-size: 20px; color: #2A3948">
                          <span>{{ service.name }}</span>
                        </div>
                        <div style="font-size: 16px; color: #999999" class="pt-1">
                          {{ `${service.price}₽` }}
                        </div>
                      </div>
                    </div>
                  </template>
                </x-radio>
              </template>
            </v-radio-group>
          </template>

          <cumulative-info-panel/>
        </div>
      </div>
    </template>
  </widget-step-page>
</template>

<script>
import WidgetStepPage from "@/components/page-template/WidgetStepPage"
import {WIDGET_STEP__SELECT_FILIAL, WIDGET_STEP__SELECT_SCHEDULE} from "@/plugins/consts"
import XAutocomplete from "@/components/x-env/autocomplete/XAutocomplete"
import {isNullOrUndefined} from "@/plugins/object-helpers"
import {mapGetters} from "vuex"
import XRadio from "@/components/x-env/radio/XRadio.vue"
import NoteTooltip from "@/components/tooltip/NoteTooltip.vue"
import CumulativeInfoPanel from "@/components/panels/CumulativeInfoPanel.vue"

export default {
  components: {
    CumulativeInfoPanel,
    NoteTooltip,
    XRadio,
    WidgetStepPage,
    XAutocomplete
  },
  data() {
    return {
      localServiceId: null,
      specialities: []
    }
  },
  async mounted() {
    await this.getServices()
    this.localServiceId = this.serviceId
  },
  computed: {
    ...mapGetters([
      'doctorId',
      'filialId',
      'specialityId',
      'serviceId',
      'serviceList',
    ]),
    isBtnNextDisabled() {
      return isNullOrUndefined(this.localServiceId)
    }
  },
  methods: {
    isNullOrUndefined,

    onBtnPrevClicked() {
      this.$store.commit('setServiceId', null)
      this.$emit('change-step', WIDGET_STEP__SELECT_FILIAL)
    },

    onBtnNextClicked() {
      if (this.isBtnNextDisabled) {
        return
      }
      this.$store.commit('setServiceId', this.localServiceId)
      this.$emit('change-step', WIDGET_STEP__SELECT_SCHEDULE)
    },

    /**
     * Получение списка услуг
     */
    async getServices() {
      this.$eventBus.$emit('show-overlay', true)
      await this.$axios
        .get(`${this.$backendLink}/widget/schedule-service`, {
          params: {
            doctorId: this.doctorId,
            filialId: this.filialId
          }
        })
        .then(response => {
          const data = response.data
          this.$store.commit('setServiceList', data.map(it => ({
            id: it.id,
            name: it.name,
            price: it.price,
            specialityId: it.specialities[0].id,
            specialityName: it.specialities[0].name
          })))
          this.specialities = data.map(it => ({
            specialityId: it.specialities[0].id,
            specialityName: it.specialities[0].name
          }))
        })
        .finally(() => {
          this.$eventBus.$emit('show-overlay', false)
        })
    }
  }
}
</script>

<style scoped>

</style>